import { useState, useEffect, useRef, useContext } from 'react';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import PageInput from '../sub-components/PageInputCopy.jsx';
import PageDropdown from '../sub-components/PageDropdownCopy.jsx';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import UserInventoryRow from '../sub-components/UserInventoryRow';
import EditUserModal from '../sub-components/EditUserModal.jsx';
import ExportExcelButton from '../sub-components/ExportExcelButton';
import AddNewUserModal from '../sub-components/AddNewUserModal.jsx';
import standardSearch from '../functions/standardSearch';
// import standardFilter from '../functions/standardFilter';
import statusFilter from '../functions/statusFilter';
import applyFilters from '../functions/applyFilters';
import { HttpContext } from '../../api-services/HttpService';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import isNullOrUndefined from '../functions/isNullOrUndefined';
import ExportPDFButton from '../sub-components/ExportPDFButton';

const UserInventoryPage = () =>{ 
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // set state for search filters
    const [searchValue, setSearchValue] = useState('');
    const [role, setRole] = useState('All');
    const [roleList, setRoleList] = useState(['All']);
    const [addRoleList, setAddRoleList] = useState(['--select--']);
    const [editRoleList, setEditRoleList] = useState([]); 
    const [status, setStatus] = useState('All');
    const [statusList, setStatusList] = useState(['All', 'Active', 'Inactive']);
    const [roleFilterData, setRoleFilterData] = useState({}); 
    const [roleRequestData, setRoleRequestData] = useState({}); 
    // set state for table
    const [showDataList, setShowDataList] = useState([]);
    const [showSortedDataList, setShowSortedDataList] = useState([]);
    // const [showDataListChange, setShowDataListChange] = useState(true);
    const [dataList, setDataList] = useState([]);
    const [tableHeader, setTableHeader] = useState([]);
    // set state for modal
    const [editUserModal, setEditUserModal] = useState(false);
    const [editUserRow, setEditUserRow] = useState({});
    const [addNewUserModal, setAddNewUserModal] = useState(false);
    // useRef to determine if initialRender
    const initialRender = useRef(true);
    // initialize spinner state
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // initialize trigger for filter functions 
    const [triggerFilter, setTriggerFilter] = useState(false); 
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);
    const [enableReset, setEnableReset] = useState(false);

    // return true if element equals roleFilterData[val] 
    const userInventoryFilter = (el, val, filterCol) => {
        console.log(val, ': ', val, '===', el[filterCol])
        if (val === 'All') {
            return true; 
        }
        else if (!isNullOrUndefined(roleFilterData[el[filterCol]])) {
            return val === roleFilterData[el[filterCol]];
        }
        else {
            return false; 
        }
    }

    // get data on refresh
    const getUsersRefresh = () => {
        setShowSpinner(showSpinner => showSpinner = true); 
        return new Promise((resolve, reject) => {
            GET('/user/inv/headers', {}).then(res => {;
                console.log(res); 
                let userInventoryData = [...res.data.UserInventory.Users];
                userInventoryData.forEach(user => user.Attributes.push( {Name: 'username', Value: user.Username}, {Name: 'last_updated', Value: user.UserLastModifiedDate}));
                //pull out custom attributes
                let userAttributes = userInventoryData.map(user => 
                    user.Attributes.reduce((acc, { Name, Value }) => ({ ...acc, [Name]: Value }), {}));
                //delete unwanted attributes
                userAttributes.forEach(user => ['sub', 'identities', 'email_verified', process.env.REACT_APP_LANDING_ATTRIBUTE].forEach(key => delete user[key]))
                //set datalist and show datalist
                setDataList(dataList => dataList = userAttributes);
                setShowDataList(showDataList => showDataList = userAttributes);
                setTableHeader(tableHeader => tableHeader = res['data']['GuiTableCols'])
                // trigger filter functions 
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // reset spinner
                setShowSpinner(showSpinner => showSpinner = false);
                resolve(res);
            }).catch(err => {
                //reset spinner
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        }); 
    }

    // get data to show in table
    const getUsers = () => { 
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            GET('/user/inv/headers', {}).then(res => {;
                console.log(res); 
                let userInventoryData = [...res.data.UserInventory.Users];
                userInventoryData.forEach(user => user.Attributes.push( {Name: 'username', Value: user.Username}, {Name: 'last_updated', Value: user.UserLastModifiedDate}));
                //pull out custom attributes
                let userAttributes = userInventoryData.map(user => 
                    user.Attributes.reduce((acc, { Name, Value }) => ({ ...acc, [Name]: Value }), {}));
                //delete unwanted attributes
                userAttributes.forEach(user => ['sub', 'identities', 'email_verified', process.env.REACT_APP_LANDING_ATTRIBUTE].forEach(key => delete user[key]))
                //set datalist and show datalist
                setDataList(dataList => dataList = userAttributes);
                setShowDataList(showDataList => showDataList = userAttributes);
                setTableHeader(tableHeader => tableHeader = res['data']['GuiTableCols']);
                // set role lists 
                setRoleList(roleList => roleList = ['All', ...res['data']['RolesList']]); 
                setAddRoleList(addRoleList => addRoleList = ['--select--', ...res['data']['RolesList']]); 
                setEditRoleList(editRoleList => editRoleList = res['data']['RolesList']); 
                // set role object for filter function
                setRoleFilterData(roleFilterData => roleFilterData = res['data']['RoleFilterObj']); 
                setRoleRequestData(roleRequestData => roleRequestData = res['data']['RoleRequestObj']); 
                // set filters
                setRole(role => role = roleList[0]);
                setStatus(status => status = statusList[0]);
                // trigger filter functions 
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // reset spinner
                setShowSpinner(showSpinner => showSpinner = false);
                setIsMenuLoaded(true);
                resolve(res);
            }).catch(err => {
                //reset spinner
                setIsMenuLoaded(false);
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }


    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader) =>{
        return( 
            <>
                <UserInventoryRow row={row} count={count} tableHeader={tableHeader} /> 
            </>
        );
    } 

    // useEffect to run on initial render
    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        if(showDataList.length) {
            setShowSortedDataList(showDataList)
        }
    }, [showDataList]);

    // useEffect to run list of search/filter functions on table data
    useEffect(() => { 
        // do not run on initial render
        if (!initialRender.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: status, flag: 1, cols: ['custom:Active']}, 
                {function: userInventoryFilter, value: role, flag: 1, cols: ['custom:Role']},
                {function: standardSearch, value: searchValue, flag: 0, cols: ['name']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(dataList, functionList);
            // update showDataList
            setShowDataList(showDataList => showDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
        
    }, [status, role, searchValue, triggerFilter]);

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // object to pass variables to PageContext
    const settings = {
        editUserModal, 
        setEditUserModal,
        editUserRow, 
        setEditUserRow, 
        addNewUserModal, 
        setAddNewUserModal, 
        addRoleList, 
        setAddRoleList, 
        getUsers,
        snackbarAlert,
        showSnackbar,
        snackbarColor,
        snackbarMessage,
        setShowSnackbar, 
        roleFilterData, 
        roleList, 
        editRoleList, 
        getUsersRefresh, 
        roleRequestData
    };

    //reset functionality 
    const resetToDefault = () => {
        setRole('All');
        setStatus('All');
        setSearchValue('');
    }

    const enableResetAll = () => {
        if(role !== 'All' || status !== 'All' || searchValue !== ''
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [role, status, searchValue, isMenuLoaded])

    // console.log(dataList,showDataList,tableHeader)
    console.log(showDataList)
    return( 
        <div class='summary-page'>
            {/* wrap children so they can access PageContext variables */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* all modals that can be activated on page. Default is hidden state */}
                <EditUserModal />
                <SnackbarAlert />
                <AddNewUserModal />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        <div className="p-3 mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex'>
                                    <div className='pe-3'>
                                        <PageDropdown tag='Status' list={statusList} value={status} setValue={setStatus} width={'7rem'} />
                                    </div>
                                    <div className='pe-3'>
                                        <PageDropdown tag={'Filter Role'} list={roleList} value={role} setValue={setRole} width={'15rem'} />
                                    </div>
                                    <div className='pe-3'>
                                        <PageInput tag='' value={searchValue} setValue={setSearchValue} width={'250px'} showSearchIcon={true}/>
                                    </div>
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                    </div>
                                </div>    
                                <div className='align-self-center'>
                                    <ExportPDFButton tag='ccap-user-inventory' dataList={showSortedDataList} tableHeader={tableHeader}/>
                                    
                                    <ExportExcelButton tag='ccap-user-inventory' dataList={dataList} tableHeader={tableHeader}/>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1" style={{ borderRadius: '12px', background: '#fff' }}>
                                <OrderedDataTable varHeight={'265px'} RowComponent={RowComponent} tableHeader={tableHeader} dataList={showDataList} setShowSortedDataList={setShowSortedDataList} showSortedDataList={showSortedDataList} showSpinner={showSpinner} numToPage={10} sortingEnabled={true} skeletonHeight='28vh'/>
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    );
}

export default UserInventoryPage;